import React from "react";
import {
  TrendingUpIcon,
  ChartIcon,
  TradeIcon,
  HistoryIcon,
  SettingsIcon,
} from "@/components/icons";

interface BottomNavigationProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

export default function BottomNavigation({
  activeTab,
  onTabChange,
}: BottomNavigationProps) {
  const tabs = [
    { id: "quotes", icon: TrendingUpIcon, label: "Quotes" },
    { id: "chart", icon: ChartIcon, label: "Chart" },
    { id: "trade", icon: TradeIcon, label: "Trade" },
    { id: "history", icon: HistoryIcon, label: "History" },
    { id: "settings", icon: SettingsIcon, label: "Settings" },
  ];

  const focusTab = (index: number) => {
    const clamped = (index + tabs.length) % tabs.length;
    const el = document.querySelectorAll<HTMLButtonElement>(
      '[data-bottom-nav-item]',
    )[clamped];
    el?.focus();
    onTabChange(tabs[clamped].id);
  };

  return (
    <nav
      className="flex-shrink-0 border-t border-border bg-background pb-[max(calc(env(safe-area-inset-bottom,0px)_-_10px),0px)]"
      aria-label="Primary"
    >
      <div className="grid grid-cols-5" role="tablist" aria-orientation="horizontal">
        {tabs.map((tab, index) => {
          const active = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              data-bottom-nav-item
              aria-selected={active}
              aria-pressed={active}
              aria-label={tab.label}
              tabIndex={active ? 0 : -1}
              onClick={() => onTabChange(tab.id)}
              onKeyDown={(e) => {
                if (e.key === "ArrowRight") {
                  e.preventDefault();
                  focusTab(index + 1);
                } else if (e.key === "ArrowLeft") {
                  e.preventDefault();
                  focusTab(index - 1);
                } else if (e.key === "Home") {
                  e.preventDefault();
                  focusTab(0);
                } else if (e.key === "End") {
                  e.preventDefault();
                  focusTab(tabs.length - 1);
                }
              }}
              className={`flex flex-col items-center pt-2.5 pb-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset ${
                active ? "text-blue-400" : "text-muted-foreground"
              }`}
            >
              <tab.icon size={24} className="mb-1" />
              <span className="text-xs">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
